import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Divider from '@mui/material/Divider';
import { TableContainer } from '@mui/material';
import TableFooter from '@mui/material/TableFooter';
import Table from '@mui/material/Table';



export default function AlreadySentDialog(props) {
    const classes = useStyles();
    const [foreignObject, setForeignObject] = useState({});
    const [objectToSave, setObjectToSave] = useState({});
    const [existingRegistration, setExistingRegistration] = useState({});

 
    useEffect(() => {
        setObjectToSave(props.objectToSave);
        setForeignObject(props.foreignObjects);
        setExistingRegistration(props.existingRegistration);

    });

    return <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}         maxWidth={'md'}
    >
                <DialogContent dividers>
                    <div className={classes.dialog}>
                        <Typography className={classes.deleteText}>Deze registratie werd reeds verzonden naar Matis!</Typography>
                        <Divider />

                        <div className={classes.spacer15}></div>
                        <p>Weet u zeker dat u deze registratie nog wil aanpassen?</p>

                        <Button autoFocus variant="outlined" onClick={props.handleClose} color="primary">
                            Annuleer
                        </Button>
                  
                        <Button className={classes.combineButton} variant="contained" onClick={() => props.handleSave()} color="primary">
                            Opslaan
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
}

const useStyles = makeStyles({
    spacer15: {
        height: '15px'  
      },
      thead: {
        border: '1px solid black',
        marginBottom: '10px',
      },
      table: {
        border: '1px solid black',
        marginBottm: '15px',
      },
      tableRow:{
        border: '1px solid black'

      },
      tableData: {
          border: '1px solid #1F8FA5',
        backgroundColor: '#1F8FA5',
        color: 'white',
      },
      paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
      },

      dialog: {
          width: "500px",
          paddingLeft: "60px",
          paddingRight: "60px",
          paddingTop: "15px",
          paddingBottom: "15px",
          justifyContent: "center",
          textAlign: "center"
      },

      deleteIcon: {
          fontSize: "100pt",
          color: "gray",
          width: "100px !important",
          height: "100px !important",
      },

      deleteText: {
          fontSize: "20pt"
      },

      deleteTexsmall: {
          fontSize: "14pt"
      },

      combineButton: {
          backgroundColor: "#1F8FA5 !important",
          margin: "10px"
      },
});